import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const categoryService = new CachedService(entities.Orderadmin_Categories_Entity_Category, '/categories/category', HALApiService, createItemsData)
